const GENRE_LABELS: Record<string, string> = {
  fantasy: 'ファンタジー',
  sf: 'SF',
  scifi: 'SF',
  horror: 'ホラー',
  mystery: 'ミステリー',
  romance: 'ロマンス',
  comedy: 'コメディ',
  literary: '文芸',
  adventure: '冒険',
  action: 'アクション',
};

const FORMAT_ALIASES: Record<string, string> = {
  short_story: 'short_story',
  novel: 'short_story',
  novels: 'short_story',
  小説: 'short_story',
  manual: 'manual',
  手引書: 'manual',
  取扱説明書: 'manual',
  grimoire: 'grimoire',
  魔導書: 'grimoire',
  魔道書: 'grimoire',
  travelogue: 'travelogue',
  旅行記: 'travelogue',
  紀行文: 'travelogue',
  '放浪記・紀行': 'travelogue',
  letter: 'letter',
  書簡: 'letter',
  '手紙・書簡': 'letter',
  memoir: 'memoir',
  '自伝・回顧録': 'memoir',
  poetry: 'poetry',
  詩: 'poetry',
};

const FORMAT_LABELS: Record<string, string> = {
  short_story: '小説',
  manual: '手引書',
  grimoire: '魔導書',
  travelogue: '紀行文',
  letter: '書簡',
  memoir: '自伝・回顧録',
  poetry: '詩',
};

export function normalizeNovelGenre(value: string | null | undefined): string {
  return (value ?? '').trim().toLowerCase();
}

export function normalizeNovelFormat(value: string | null | undefined): string {
  const raw = (value ?? '').trim();
  return FORMAT_ALIASES[raw] ?? raw.toLowerCase();
}

export function getNovelGenreLabel(value: string | null | undefined): string {
  const normalized = normalizeNovelGenre(value);
  return GENRE_LABELS[normalized] ?? (value ?? '');
}

export function getNovelFormatLabel(value: string | null | undefined): string {
  const normalized = normalizeNovelFormat(value);
  return FORMAT_LABELS[normalized] ?? (value ?? '');
}

export function getSupplementaryWorldTags(
  primaryGenre: string | null | undefined,
  worldTags: string[] | null | undefined,
): string[] {
  const primary = normalizeNovelGenre(primaryGenre);
  const tags = Array.isArray(worldTags) ? worldTags : [];
  return [...new Set(tags.map((tag) => normalizeNovelGenre(tag)).filter((tag) => tag && tag !== primary))];
}
